export default "__VITE_ASSET__CBi3Zt0I__"